<template>
  <div class="messageList" v-if="this.language == 'eng'">
    <div class="messageList_top wow animate__animated animate__fadeInDown">
      <div class="messageList_top_title">
        <div class="title_ring eng_title_ring">
          <div class="hotArt_text eng_hotArt_text">{{ message.eng_title }}</div>
        </div>
      </div>
      <div
        class="messageIntroduce eng_messageIntroduce wow animate__animated animate__fadeIn"
      >
        {{ message.eng_introduce }}
      </div>
      <div class="works">
        <div
          class="workItem"
          v-for="(item, index) in message.worksImages"
          :key="index"
        >
          <img :src="item.imgSrc" alt="" />
          <div class="name eng_name">{{ item.eng_name }}</div>
        </div>
      </div>
    </div>
    <div class="messageList_bottom wow animate__animated animate__fadeInDown">
      <div class="make">
        <div class="title_ring">
          <div class="hotArt_text eng_hotArt_text">Production process</div>
        </div>
      </div>
      <div class="video hidden-xs-only">
        <div class="videoItem" v-if="message.videoList">
          <div class="left">
            <div class="left_one" @click="play(5)">
              <img
                src="../../src/assets/newImage/index/hot_art.png"
                alt=""
                title="点击播放视频"
              />
              <div class="topic">
                <div class="topic_text eng_topic_text">ReGong Hot</div>
              </div>
              <div class="videoMask">
                <div class="around">
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
            <div class="left_one" @click="play(2)">
              <img
                src="../../src/assets/dataType/data_ni.jpeg"
                alt=""
                title="点击播放视频"
              />
              <div class="topic">
                <div class="topic_text eng_topic_text">Clay sculpture</div>
              </div>
              <div class="videoMask">
                <div class="around">
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="top">
              <div class="topLeft" @click="play(0)">
                <div class="one">
                  <img
                    src="../../src/assets/newImage/index/video_tang_1.jpg"
                    alt=""
                    title="点击播放视频"
                  />
                  <div class="topic">
                    <div class="topic_text eng_topic_text">Thangka</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="topRight" @click="play(1)">
                <div class="two">
                  <img
                    src="../../src/assets/dataType/data_dui.png"
                    alt=""
                    title="点击播放视频"
                  />
                  <div class="topic">
                    <div class="topic_text eng_topic_text">Pile embroidery</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="bottom_left" @click="play(4)">
                <div class="one">
                  <img
                    src="../../src/assets/dataType/data_cai.jpg"
                    alt=""
                    title="点击播放视频"
                  />
                  <div class="topic">
                    <div class="topic_text eng_topic_text">Paintings</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="bottom_right" @click="play(3)">
                <div class="two">
                  <img
                    src="../../src/assets/dataType/buhua.png"
                    alt=""
                    title="点击播放视频"
                  />
                  <div class="topic">
                    <div class="topic_text eng_topic_text">Mural</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile_video hidden-sm-and-up">
        <div class="mobile_video_top">
          <div class="videoItems" @click="play(5)">
            <img
              src="../../src/assets/newImage/index/hot_art.png"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text eng_topic_text">ReGong Hot</div>
            </div>
          </div>
          <div class="videoItems" @click="play(0)">
            <img
              src="../../src/assets/newImage/index/video_tang_1.jpg"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text eng_topic_text">Thangka</div>
            </div>
          </div>
        </div>
        <div class="mobile_video_middle">
          <div class="videoItems" @click="play(1)">
            <img
              src="../../src/assets/dataType/data_dui.png"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text eng_topic_text">Pile embroidery</div>
            </div>
          </div>
          <div class="videoItems" @click="play(2)">
            <img
              src="../../src/assets/dataType/data_ni.jpeg"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text eng_topic_text">Clay sculpture</div>
            </div>
          </div>
        </div>
        <div class="mobile_video_bottom">
          <div class="videoItems" @click="play(4)">
            <img
              src="../../src/assets/dataType/data_cai.jpg"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text eng_topic_text">Paintings</div>
            </div>
          </div>
          <div class="videoItems" @click="play(3)">
            <img
              src="../../src/assets/dataType/buhua.png"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text eng_topic_text">Mural</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow" @click.stop.prevent="writeMessageFun($event)">
      <div class="section" ref="modal">
        <div @click="closePlay" class="closeVideo">
          <img src="../assets/newImage/index/closeVideo.png" alt="" />
        </div>
        <video-player class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            style="object-fit:fill"
            :options="playerOptions"
            :x5-video-player-fullscreen="true"
            @fullscreenchange="onFullscreenChange($event)"
            @click="fullScreen"
        >
        </video-player>
      </div>
    </div>
  </div>
  <div class="messageList" v-else-if="this.language == 'en'">
    <div class="messageList_top wow animate__animated animate__fadeInDown">
      <div class="messageList_top_title">
        <div class="title_ring">
          <div class="hotArt_text za_hotArt_text">{{ message.za_title }}</div>
        </div>
      </div>
      <div class="messageIntroduce wow animate__animated animate__fadeIn">
        {{ message.za_introduce }}
      </div>
      <div class="works">
        <div
          class="workItem"
          v-for="(item, index) in message.worksImages"
          :key="index"
        >
          <img :src="item.imgSrc" alt="" />
          <div class="name">{{ item.za_name }}</div>
        </div>
      </div>
    </div>
    <div class="messageList_bottom wow animate__animated animate__fadeInDown">
      <div class="make">
        <div class="title_ring">
          <div class="hotArt_text za_hotArt_text">བཟོ་རྩལ།</div>
        </div>
      </div>
      <div class="video hidden-xs-only">
        <div class="videoItem" v-if="message.videoList">
          <div class="left">
            <div class="left_one" @click="play(5)">
              <img
                src="../../src/assets/newImage/index/hot_art.png"
                alt=""
                title="བརྙན་ལམ་ལ་གནོན་།"
              />
              <div class="topic">
                <div class="topic_text">རེབ་གོང་སྒྱུ་རྩལ་</div>
              </div>
              <div class="videoMask">
                <div class="around">
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
            <div class="left_one" @click="play(2)">
              <img
                src="../../src/assets/dataType/data_ni.jpeg"
                alt=""
                title="བརྙན་ལམ་ལ་གནོན་།"
              />
              <div class="topic">
                <div class="topic_text">འཇིམ་བཟོ།</div>
              </div>
              <div class="videoMask">
                <div class="around">
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="top">
              <div class="topLeft" @click="play(0)">
                <div class="one">
                  <img
                    src="../../src/assets/newImage/index/video_tang_1.jpg"
                    alt=""
                    title="བརྙན་ལམ་ལ་གནོན་།"
                  />
                  <div class="topic">
                    <div class="topic_text">ཐང་ག</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="topRight" @click="play(1)">
                <div class="two">
                  <img
                    src="../../src/assets/dataType/data_dui.png"
                    alt=""
                    title="བརྙན་ལམ་ལ་གནོན་།"
                  />
                  <div class="topic">
                    <div class="topic_text">རེབ་གོང་</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="bottom_left" @click="play(4)">
                <div class="one">
                  <img
                    src="../../src/assets/dataType/data_cai.jpg"
                    alt=""
                    title="བརྙན་ལམ་ལ་གནོན་།"
                  />
                  <div class="topic">
                    <div class="topic_text">ཚོན་རིས།</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="bottom_right" @click="play(3)">
                <div class="two">
                  <img
                    src="../../src/assets/dataType/buhua.png"
                    alt=""
                    title="བརྙན་ལམ་ལ་གནོན་།"
                  />
                  <div class="topic">
                    <div class="topic_text">ལྡེབས་རིས།</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile_video hidden-sm-and-up">
        <div class="mobile_video_top">
          <div class="videoItems" @click="play(5)">
            <img
              src="../../src/assets/newImage/index/hot_art.png"
              alt=""
              title="བརྙན་ལམ་ལ་གནོན་།"
            />
            <div class="topic">
              <div class="topic_text">རེབ་གོང་སྒྱུ་རྩལ་</div>
            </div>
          </div>
          <div class="videoItems" @click="play(0)">
            <img
              src="../../src/assets/newImage/index/video_tang_1.jpg"
              alt=""
              title="བརྙན་ལམ་ལ་གནོན་།"
            />
            <div class="topic">
              <div class="topic_text">ཐང་ག</div>
            </div>
          </div>
        </div>
        <div class="mobile_video_middle">
          <div class="videoItems" @click="play(1)">
            <img
              src="../../src/assets/dataType/data_dui.png"
              alt=""
              title="བརྙན་ལམ་ལ་གནོན་།"
            />
            <div class="topic">
              <div class="topic_text">རེབ་གོང་</div>
            </div>
          </div>
          <div class="videoItems" @click="play(2)">
            <img
              src="../../src/assets/dataType/data_ni.jpeg"
              alt=""
              title="བརྙན་ལམ་ལ་གནོན་།"
            />
            <div class="topic">
              <div class="topic_text">འཇིམ་བཟོ།</div>
            </div>
          </div>
        </div>
        <div class="mobile_video_bottom">
          <div class="videoItems" @click="play(4)">
            <img
              src="../../src/assets/dataType/data_cai.jpg"
              alt=""
              title="བརྙན་ལམ་ལ་གནོན་།"
            />
            <div class="topic">
              <div class="topic_text">ཚོན་རིས།</div>
            </div>
          </div>
          <div class="videoItems" @click="play(3)">
            <img
              src="../../src/assets/dataType/buhua.png"
              alt=""
              title="བརྙན་ལམ་ལ་གནོན་།"
            />
            <div class="topic">
              <div class="topic_text">ལྡེབས་རིས།</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow" @click.stop.prevent="writeMessageFun($event)">
      <div class="section" ref="modal">
        <div @click="closePlay" class="closeVideo">
          <img src="../assets/newImage/index/closeVideo.png" alt="" />
        </div>
        <video-player class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            style="object-fit:fill"
            :options="playerOptions"
            :x5-video-player-fullscreen="true"
            @fullscreenchange="onFullscreenChange($event)"
            @click="fullScreen"
        >
        </video-player>
      </div>
    </div>
  </div>
  <div class="messageList" v-else>
    <div class="messageList_top wow animate__animated animate__fadeInDown">
      <div class="messageList_top_title">
        <div class="title_ring">
          <div class="hotArt_text">{{ message.title }}</div>
        </div>
      </div>
      <div class="messageIntroduce wow animate__animated animate__fadeIn">
        {{ message.introduce }}
      </div>
      <div class="works">
        <div
          class="workItem"
          v-for="(item, index) in message.worksImages"
          :key="index"
        >
          <img :src="item.imgSrc" alt="" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="messageList_bottom wow animate__animated animate__fadeInDown">
      <div class="make">
        <div class="title_ring">
          <div class="hotArt_text">制作工艺</div>
        </div>
      </div>
      <div class="video hidden-xs-only">
        <div class="videoItem" v-if="message.videoList">
          <div class="left">
            <div class="left_one" @click="play(5)">
              <img
                src="../../src/assets/newImage/index/hot_art.png"
                alt=""
                title="点击播放视频"
              />
              <div class="topic">
                <div class="topic_text">热贡艺术</div>
              </div>
              <div class="videoMask">
                <div class="around">
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
            <div class="left_one" @click="play(2)">
              <img
                src="../../src/assets/dataType/data_ni.jpeg"
                alt=""
                title="点击播放视频"
              />
              <div class="topic">
                <div class="topic_text">泥塑</div>
              </div>
              <div class="videoMask">
                <div class="around">
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="top">
              <div class="topLeft" @click="play(0)">
                <div class="one">
                  <img
                    src="../../src/assets/newImage/index/video_tang_1.jpg"
                    alt=""
                    title="点击播放视频"
                  />
                  <div class="topic">
                    <div class="topic_text">唐卡</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="topRight" @click="play(1)">
                <div class="two">
                  <img
                    src="../../src/assets/dataType/data_dui.png"
                    alt=""
                    title="点击播放视频"
                  />
                  <div class="topic">
                    <div class="topic_text">堆绣</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="bottom_left" @click="play(4)">
                <div class="one">
                  <img
                    src="../../src/assets/dataType/data_cai.jpg"
                    alt=""
                    title="点击播放视频"
                  />
                  <div class="topic">
                    <div class="topic_text">彩绘</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottom_right" @click="play(3)">
                <div class="two">
                  <img
                    src="../../src/assets/dataType/buhua.png"
                    alt=""
                    title="点击播放视频"
                  />
                  <div class="topic">
                    <div class="topic_text">壁画</div>
                  </div>
                  <div class="videoMask">
                    <div class="around">
                      <div class="triangle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile_video hidden-sm-and-up">
        <div class="mobile_video_top">
          <div class="videoItems" @click="play(5)">
            <img
              src="../../src/assets/newImage/index/hot_art.png"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text">热贡艺术</div>
            </div>
          </div>
          <div class="videoItems" @click="play(0)">
            <img
              src="../../src/assets/newImage/index/video_tang_1.jpg"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text">唐卡</div>
            </div>
          </div>
        </div>
        <div class="mobile_video_middle">
          <div class="videoItems" @click="play(1)">
            <img
              src="../../src/assets/dataType/data_dui.png"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text">堆绣</div>
            </div>
          </div>
          <div class="videoItems" @click="play(2)">
            <img
              src="../../src/assets/dataType/data_ni.jpeg"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text">泥塑</div>
            </div>
          </div>
        </div>
        <div class="mobile_video_bottom">
          <div class="videoItems" @click="play(4)">
            <img
              src="../../src/assets/dataType/data_cai.jpg"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text">彩绘</div>
            </div>
          </div>
          <div class="videoItems" @click="play(3)">
            <img
              src="../../src/assets/dataType/buhua.png"
              alt=""
              title="点击播放视频"
            />
            <div class="topic">
              <div class="topic_text">壁画</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow" @click.stop.prevent="writeMessageFun($event)">
      <div class="section" ref="modal">
        <video-player class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            style="object-fit:fill"
            :options="playerOptions"
            :x5-video-player-fullscreen="true"
            @fullscreenchange="onFullscreenChange($event)"
            @click="fullScreen"
        >
        </video-player>
        <div @click="closePlay" class="closeVideo">
          <img src="../assets/newImage/index/closeVideo.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  data() {
    return {
      maskShow: false,
      num: null,
      language: this.$store.state.language,
      url: process.env.VUE_APP_WEB_URL,
      playerOptions: {
          playbackRates: [0.7, 1.0, 1.25, 1.5, 2.0], //播放速度
          autoplay: true, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
              type: "video/mp4",
              src:""
          }],
          poster: "",
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            progressControl: true, //是否显示进度条
            fullscreenToggle: false  //全屏按钮
          }
      },
    };
  },
  created() {

  },
  methods: {
    play(num) {
      this.maskShow = true;
      this.num = num;
      this.playerOptions.sources[0].src = this.message.videoList[num].imgSrc
      let body = document.getElementsByTagName('body')[0]
      body.style.overflow='hidden'
    },
    closePlay() {
      this.maskShow = false;
      let body = document.getElementsByTagName('body')[0]
      body.style.overflow=null
    },
    writeMessageFun (ev) {
      let dom = this.$refs.modal
      if(dom) {
        if(!dom.contains(ev.target)) {
          this.maskShow = false;
          let body = document.getElementsByTagName('body')[0]
          body.style.overflow=null
        }
      }
    },
    fullScreen() {
        const player = this.$refs.videoPlayer.player
        player.requestFullscreen()//调用全屏api方法
        player.isFullscreen(true)
        player.play()
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.messageList {
  .messageList_top {
    .messageList_top_title {
      display: flex;
      justify-content: center;
      .title_ring {
        margin: 30px 0 50px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url("../assets/newImage/index/text_ring_red.png") no-repeat
          center;
        background-size: cover;
        width: 254px;
        height: 80px;
        text-align: center;
        .hotArt_text {
          padding-top: 10px;
          font-family: "fangzang";
          letter-spacing: 4px;
          font-size: 44px;
          margin: 0 4px;
          color: #981218;
        }
        .za_hotArt_text {
          font-size: 22px;
          text-align: center;
          white-space: normal;
        }
        .eng_hotArt_text {
          font-family: "Times New Roman", Times, serif;
        }
      }
      .eng_title_ring {
        width: 270px;
        height: 84px;
        padding: 10px;
        .eng_hotArt_text {
          font-size: 28px;
          white-space: normal;
          text-align: center;
        }
      }
    }
    .messageIntroduce {
      text-indent: 2em;
      font-size: 20px;
      text-align: justify;
      line-height: 1.5;
    }
    .eng_messageIntroduce {
      text-indent: 0;
      letter-spacing: 1px;
    }
    .works {
      margin: 30px 0 0 0;
      display: flex;
      justify-content: space-between;
      .workItem {
        width: 540px;
        // height: 300px;
        // margin-bottom: 40px;
        img {
          width: 100%;
          height: 300px;
          margin-bottom: 20px;
        }
        .name {
          font-size: 26px;
          font-family: "fangzang";
          text-align: center;
        }
        .eng_name {
          font-family: "Times New Roman", Times, serif;
        }
      }
      .workItem:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .messageList_bottom {
    margin-top: 30px;
    .make {
      display: flex;
      justify-content: center;
      .title_ring {
        margin: 30px 0 50px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url("../assets/newImage/index/text_ring_red.png") no-repeat
          center;
        background-size: cover;
        width: 240px;
        height: 76px;
        text-align: center;
        .hotArt_text {
          padding-top: 10px;
          font-family: "fangzang";
          letter-spacing: 4px;
          font-size: 44px;
          margin: 0 4px;
          color: #981218;
        }
        .za_hotArt_text {
          line-height: 70px;
          font-size: 34px;
          text-align: center;
        }
        .eng_hotArt_text {
          font-family: "Times New Roman", Times, serif;
          font-size: 22px;
        }
      }
    }
    .video {
      display: flex;
      .topic_text {
        font-family: "fangzang";
      }
      .eng_topic_text {
        font-family: "Times New Roman", Times, serif;
      }
      .videoItem {
        display: flex;
        .left {
          display: flex;
          flex-direction: column;
          .left_one {
            overflow: hidden;
            width: 370px;
            height: 240px;
            position: relative;
            margin-right: 40px;
            cursor: pointer;
            img {
              width: 370px;
              height: 240px;
            }
            .topic {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 370px;
              height: 50px;
              line-height: 50px;
              background-color: rgba(0, 0, 0, 0.3);
              transition: all 0.4s linear;
              .topic_text {
                color: #fff;
                text-align: center;
                font-size: 30px;
              }
            }
            .videoMask {
              width: 100%;
              height: 240px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgba(0, 0, 0, 0.3);
              transition: all 0.5s linear;
              .around {
                width: 80px;
                height: 80px;
                border-radius: 100%;
                border: 3px solid #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                .triangle {
                  border-style: solid;
                  border-color: transparent;
                  border-width: 16px 0 16px 20px;
                  border-left-color: #fff;
                }
              }
            }

          }
          .left_one:first-child {
            margin-bottom: 40px;
          }
          .left_one:hover {
            .topic {
              transform: translateY(50.2px);
              animation-play-state: running;
            }
            .videoMask {
              transform: translateY(-242px);
              animation-play-state: running;
            }
          }
        }
        .right {
          width: 780px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .top {
            display: flex;
            .topLeft {
              position: relative;
              margin-right: 40px;
              width: 370px;
              height: 240px;
              overflow: hidden;
              cursor: pointer;
              .one {
                width: 100%;
                height: 100%;
                img {
                  width: 100%;
                  height: 100%;
                }
                .topic {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 370px;
                  height: 50px;
                  line-height: 50px;
                  background-color: rgba(0, 0, 0, 0.3);
                  transition: all 0.4s linear;
                  .topic_text {
                    color: #fff;
                    text-align: center;
                    font-size: 30px;
                  }
                }
                .videoMask {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: rgba(0, 0, 0, 0.3);
                  transition: all 0.5s linear;
                  .around {
                    width: 80px;
                    height: 80px;
                    border-radius: 100%;
                    border: 3px solid #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .triangle {
                      border-style: solid;
                      border-color: transparent;
                      border-width: 16px 0 16px 20px;
                      border-left-color: #fff;
                    }
                  }
                }
              }
              .one:hover {
                .topic {
                  transform: translateY(50.2px);
                  animation-play-state: running;
                }
                .videoMask {
                  transform: translateY(-242px);
                  animation-play-state: running;
                }
              }
            }
            .topRight {
              position: relative;
              width: 374px;
              height: 240px;
              overflow: hidden;
              cursor: pointer;
              .two {
                width: 100%;
                height: 100%;
                img {
                  width: 100%;
                  height: 100%;
                }
                .topic {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 370px;
                  height: 50px;
                  line-height: 50px;
                  background-color: rgba(0, 0, 0, 0.3);
                  transition: all 0.4s linear;
                  .topic_text {
                    color: #fff;
                    text-align: center;
                    font-size: 30px;
                  }
                }
                .videoMask {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: rgba(0, 0, 0, 0.3);
                  transition: all 0.5s linear;
                  .around {
                    width: 80px;
                    height: 80px;
                    border-radius: 100%;
                    border: 3px solid #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .triangle {
                      border-style: solid;
                      border-color: transparent;
                      border-width: 16px 0 16px 20px;
                      border-left-color: #fff;
                    }
                  }
                }
              }
              .two:hover {
                .topic {
                  transform: translateY(50.2px);
                  animation-play-state: running;
                }
                .videoMask {
                  transform: translateY(-242px);
                  animation-play-state: running;
                }
              }
            }
          }
          .bottom {
            display: flex;
            .bottom_left {
              position: relative;
              margin-right: 40px;
              width: 370px;
              height: 240px;
              overflow: hidden;
              cursor: pointer;
              .one {
                width: 100%;
                height: 100%;
                img {
                  width: 100%;
                  height: 100%;
                  vertical-align: bottom;
                }
                .topic {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 370px;
                  height: 50px;
                  line-height: 50px;
                  background-color: rgba(0, 0, 0, 0.3);
                  transition: all 0.4s linear;
                  .topic_text {
                    color: #fff;
                    text-align: center;
                    font-size: 30px;
                  }
                }
                .videoMask {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: rgba(0, 0, 0, 0.3);
                  transition: all 0.5s linear;
                  .around {
                    width: 80px;
                    height: 80px;
                    border-radius: 100%;
                    border: 3px solid #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .triangle {
                      border-style: solid;
                      border-color: transparent;
                      border-width: 16px 0 16px 20px;
                      border-left-color: #fff;
                    }
                  }
                }
              }
              .one:hover {
                .topic {
                  transform: translateY(50.2px);
                  animation-play-state: running;
                }
                .videoMask {
                  transform: translateY(-241px);
                  animation-play-state: running;
                }
              }
            }
            .bottom_right {
              position: relative;
              width: 374px;
              height: 240px;
              overflow: hidden;
              cursor: pointer;
              .two {
                width: 100%;
                height: 100%;
                img {
                  width: 100%;
                  height: 100%;
                }
                .topic {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 370px;
                  height: 50px;
                  line-height: 50px;
                  background-color: rgba(0, 0, 0, 0.3);
                  transition: all 0.4s linear;
                  .topic_text {
                    color: #fff;
                    text-align: center;
                    font-size: 30px;
                  }
                }
                .videoMask {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: rgba(0, 0, 0, 0.3);
                  transition: all 0.5s linear;
                  .around {
                    width: 80px;
                    height: 80px;
                    border-radius: 100%;
                    border: 3px solid #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .triangle {
                      border-style: solid;
                      border-color: transparent;
                      border-width: 16px 0 16px 20px;
                      border-left-color: #fff;
                    }
                  }
                }
              }
              .two:hover {
                .topic {
                  transform: translateY(50.2px);
                  animation-play-state: running;
                }
                .videoMask {
                  transform: translateY(-241px);
                  animation-play-state: running;
                }
              }
            }
          }
        }
      }
    }
  }
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    .section {
      position: relative;
      video {
        width: 1100px;
      }
      .video-player {
        .video-js {
          .vjs-control-bar {
            .vjs-progress-control {
              .vjs-progress-holder {
                .vjs-play-progress:before {
                  top: 1px;
                }
              }
            }
            .vjs-volume-panel{
              .vjs-volume-control {
                .vjs-volume-bar {
                  .vjs-volume-level:before {
                    top: 1px;
                  }
                }
              }
            }
          }
        }
      }
      .closeVideo {
        z-index: 9999;
        position: absolute;
        top: 0;
        right: 10px;
        background-color: #981118;
        margin-bottom: 20px;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 30px;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .messageList {
    padding-bottom: 0.6rem;
    .messageList_top {
      .messageList_top_title {
        display: flex;
        justify-content: center;
        .title_ring {
          margin: 0.5rem 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: url("../assets/newImage/index/text_ring_red.png")
            no-repeat center;
          background-size: contain;
          width: 2.8rem;
          height: 0.9rem;
          .hotArt_text {
            text-align: center;
            white-space: normal;
            padding-top: 0.15rem;
            letter-spacing: 4px;
            font-size: 0.5rem;
            margin: 0 4px;
            color: #981218;
            font-family: 'fangzang';
          }
          .za_hotArt_text {
            font-size: 0.2rem;
          }
          .eng_hotArt_text {
            font-size: 0.27rem;
          }
        }
      }
      .messageIntroduce {
        font-size: 0.28rem;
        text-indent: 2em;
        height: 5rem;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow: scroll;
        line-height: 1.5;
        text-align: justify;
      }
      .messageIntroduce::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .works {
        margin: 0.3rem 0 0 0;
        display: flex;
        flex-wrap: wrap;
        .workItem {
          width: 3.25rem;
          // height: 2.8rem;
          margin-right: 0.4rem;
          margin-bottom: 0;
          img {
            width: 3.25rem;
            height: 2.4rem;
            margin-bottom: 0;
          }
          .name {
            font-size: 0.36rem;
            padding: 0.1rem 0;
          }
        }
        .workItem:nth-child(2n) {
          margin-right: 0 !important;
        }
      }
    }
    .messageList_bottom {
      margin-top: 0;
      .make {
        display: flex;
        justify-content: center;
        .title_ring {
          margin: 0.3rem 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: url("../assets/newImage/index/text_ring_red.png")
            no-repeat center;
          background-size: contain;
          width: 2.8rem;
          height: 0.9rem;
          .hotArt_text {
            letter-spacing: 4px;
            font-size: 0.5rem;
            margin: 0 4px;
            color: #981218;
          }
          .za_hotArt_text {
            margin-top: -0.3rem;
          }
          .eng_hotArt_text {
            font-size: 0.27rem;
            text-align: center;
            white-space: normal;
          }
        }
      }
      .make_two {
        margin-bottom: 0.3rem;
        font-family: "fangzang";
        line-height: 20px;
        font-size: 0.25rem;
      }
      .messageIntroduce {
        text-indent: 2em;
        line-height: 1.5;
      }
      .eng_messageIntroduce {
        text-indent: 0;
      }
    }
    .mobile_video {
      padding-bottom: 0.1rem;
      .mobile_video_top {
        margin: 0.5rem 0;
        display: flex;
        justify-content: space-between;
        .videoItems {
          position: relative;
          width: 3.3rem;
          height: 2.4rem;
          img {
            width: 3.3rem;
            height: 2.4rem;
          }
          .topic {
            height: 0.6rem;
            line-height: 0.6rem;
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.3);
            .topic_text {
              color: #fff;
              text-align: center;
              font-size: 0.35rem;
            }
          }
        }
      }
      .mobile_video_middle {
        margin: 0.5rem 0;
        display: flex;
        justify-content: space-between;
        .videoItems {
          position: relative;
          width: 3.3rem;
          height: 2.4rem;
          img {
            width: 3.3rem;
            height: 2.4rem;
          }
          .topic {
            height: 0.6rem;
            line-height: 0.6rem;
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.3);
            .topic_text {
              color: #fff;
              text-align: center;
              font-size: 0.35rem;
            }
          }
        }
      }
      .mobile_video_bottom {
        margin: 0.5rem 0;
        display: flex;
        justify-content: space-between;
        .videoItems {
          position: relative;
          width: 3.3rem;
          height: 2.4rem;
          img {
            width: 100%;
            height: 2.4rem;
          }
          .topic {
            height: 0.6rem;
            line-height: 0.6rem;
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.3);
            .topic_text {
              color: #fff;
              text-align: center;
              font-size: 0.35rem;
            }
          }
        }
      }
    }
    .mask {
      .section {
        padding: 0;
        video {
          width: 100%;
        }
        .closeVideo {
          top: 2px;
          right: 10px;
          width: 30px;
          height: 30px;
          img {
            width: 20px;
          } 
        }
      }
    }
  }
}
</style>